module.exports = __webpack_public_path__ + "img/icon_map_0_on_100.b1c5f12d.png";